import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import WhyChooseUs from './components/WhyChooseUs';
import SkiResorts from './components/SkiResorts';
import TripConfigurator from './components/TripConfigurator';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <WhyChooseUs />
      <SkiResorts />
      <TripConfigurator />
      <Footer />
    </div>
  );
}

export default App;
